import { register } from 'tmr/tmr/ngModuleRegistry'

import * as accessControl from './accessControl/accessControl'
import * as connectionManager from './connectionManager/connectionManager'

export let accessControlNgModule = register(
  'tmr.core.accessControl',
  accessControl
)
export let connectionManagerNgModule = register(
  'tmr.core.connectionManager',
  connectionManager
)
